import { Plus } from 'iconoir-react'
import { useState } from 'react'
import { Validator } from 'remix-validated-form'
import { Button } from 'app/components/ui/button'
import { FormInput } from 'app/components/ui/form-input'
import { FormSelect } from 'app/components/form/FormComboSelect'
import { Label } from 'app/components/ui/label'
import { SmartForm } from 'app/components/ui/smart-form'

const scheduleOptions = [
  { label: `Daily`, value: `DAILY` },
  { label: `Weekly`, value: `WEEKLY` },
  { label: `Monthly`, value: `MONTHLY` },
]

const typeOptions = [
  { label: `Thing`, value: `THING` },
  { label: `Other thing`, value: `OTHER_THING` },
]

export type ReportsShadcnComponentProps = {
  validator: Validator<any>
}

export function ReportsShadcnComponent({ validator }: ReportsShadcnComponentProps) {
  const [emailInputs, setEmailInputs] = useState<number[]>([0])

  return (
    <SmartForm
      validator={validator}
      defaultValues={{ isActive: true }}
      replace={true}
      method="post"
      hiddenInputs={[{ name: `workspaceId`, value: `as` }]}
    >
      <div className="col-span-12 md:col-span-6">
        <Label className="text-ui-sm">
          <div className="inline-flex items-center gap-x-2">
            <span>Add email</span>
            <Button
              type="button"
              variant="primary"
              size="xs"
              onClick={() => setEmailInputs((prev) => [...prev, prev.length])}
            >
              <Plus className="h-4 w-4" />
            </Button>
          </div>
        </Label>
        {emailInputs.map((_, i) => (
          <div key={i} className="mb-2">
            <FormInput name="emails" type="email" cols={6} />
          </div>
        ))}
      </div>
      <FormSelect label="Interval" name="schedule" cols={6} options={scheduleOptions} />
      <FormSelect label="Report type" name="type" cols={6} options={typeOptions} />
      <FormInput label="Enable" name="isActive" type="checkbox" className="w-4 rounded" />
    </SmartForm>
  )
}
